'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchFinancesIfNeeded = exports.failureFinances = exports.receiveFinances = exports.requestFinances = exports.invalidateFinances = exports.filterFinances = exports.INVALIDATE_FINANCES = exports.FILTER_FINANCES = exports.FAILURE_FINANCES = exports.RECEIVE_FINANCES = exports.REQUEST_FINANCES = undefined;

var _css = require('antd/lib/notification/style/css');

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_FINANCES = exports.REQUEST_FINANCES = 'REQUEST_FINANCES'; /**
                                                                       * 财务相关Actions
                                                                       */
var RECEIVE_FINANCES = exports.RECEIVE_FINANCES = 'RECEIVE_FINANCES';
var FAILURE_FINANCES = exports.FAILURE_FINANCES = 'FAILURE_FINANCES';
var FILTER_FINANCES = exports.FILTER_FINANCES = 'FILTER_FINANCES';
var INVALIDATE_FINANCES = exports.INVALIDATE_FINANCES = 'INVALIDATE_FINANCES';

var filterFinances = exports.filterFinances = function filterFinances(filter) {
    return {
        type: FILTER_FINANCES,
        filter: filter
    };
};

var invalidateFinances = exports.invalidateFinances = function invalidateFinances(filter) {
    return {
        type: INVALIDATE_FINANCES,
        filter: filter
    };
};

var requestFinances = exports.requestFinances = function requestFinances(filter) {
    return {
        type: REQUEST_FINANCES,
        filter: filter
    };
};

var receiveFinances = exports.receiveFinances = function receiveFinances(filter, response) {
    return {
        type: RECEIVE_FINANCES,
        filter: filter,
        finances: response.data,
        pagination: response.meta.pagination
    };
};
var failureFinances = exports.failureFinances = function failureFinances(error) {
    return {
        type: FAILURE_FINANCES,
        error: error
    };
};

var shouldFetchFinances = function shouldFetchFinances(state, filter) {
    var finances = state.finance.finances;
    if (finances.items.length === 0) {
        return true;
    }
    if (finances.isFetching) {
        return false;
    }
    return true;
};

var fetchFinancesIfNeeded = exports.fetchFinancesIfNeeded = function fetchFinancesIfNeeded(filter, page) {
    return function (dispatch, getState) {
        return (0, _api.fetchFinances)(filter, page).then(function (response) {
            dispatch(receiveFinances(filter, response.data));
        }).catch(function (error) {
            _notification2.default['error']({
                message: '获取失败',
                description: error.response && error.response.data && error.response.data.message
            });
            dispatch(failureFinances(error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/finance.js
// module id = 886
// module chunks = 0